import { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import SubHeader from "../../components/SubHeader";
import grave from '../../img/grave.jpg';
import MafiaService from "../../services/mafiaService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { setDeadView, setGameMode, setPlayerView } from "../../store/gameSlice";
import { IDeadView } from "../../types/IDeadView";
import { showErrorToast } from "../../store/messageSlice";
import { DeadModeEnum } from "../../types/deadModeEnum";
import ScenarioUtils from "../../utils/scenarioUtils";
import { RoleClassEnum } from "../../types/roleClassEnum";
import GameLogs from "../../components/GameLogs";
import { IPlayerView } from "../../types/IPlayerView";
import { GameModeEnum } from "../../types/gameModeEnum";
import ConfirmPopup from "../../components/ConfirmPopup";
import useWebSocket from "react-use-websocket";

function Dead() {
    const dispatch = useDispatch();
    const { serverName, playerName, role } = useSelector((state: RootState) => state.general);
    const { deadView } = useSelector((state: RootState) => state.game);
    const [deadMode, setDeadMode] = useState(DeadModeEnum.Dead);
    const [confirmPopup, setConfirmPopup] = useState(false);
    const [isNight, setNight ] = useState(false);

    useEffect(() => {
        getDeadView();
        const interval = setInterval(() => {
          getDeadView();
          pollPlayers();
        }, 2000);    
        return () => clearInterval(interval);
      }, []);

    const { lastJsonMessage } = useWebSocket(
        `${process.env.REACT_APP_SERVER_URL}/game_time/${serverName}`,
        {
            share: false,
            shouldReconnect: () => true,
        },
    )

    useEffect(() => {
        if (lastJsonMessage) {
            const { time_of_day, time_left, day } = lastJsonMessage;
            setNight(time_of_day === 'Night');
        }
    }, [lastJsonMessage]);

    const pollPlayers = () => {
        MafiaService.PlayerView(serverName, playerName, (is_ok, payload) => {
            if (is_ok) {
                const playerView = payload as IPlayerView;
                dispatch(setPlayerView(playerView));
                if (playerView.winners?.length > 0) {
                    dispatch(setGameMode(GameModeEnum.End));
                }
            } else {
                dispatch(showErrorToast(payload))
            }
        })
    }

    const getDeadView = () => {        
        MafiaService.GetDeadView(serverName, (is_ok, payload) => {
            if (is_ok) {
                dispatch(setDeadView(payload as IDeadView));
            } else {
                dispatch(showErrorToast(payload))
            }
        });
    }

    if (confirmPopup) {
        const confirmCallback = () => {
            if (isNight) {
                MafiaService.EndNight(serverName);

            } else {
                MafiaService.EndDay(serverName);
            }
        }

        return <div className="mafia-container-wrapper">
            <div className="mafia-container">
                <ConfirmPopup message="Are you sure?" onConfirm={confirmCallback} onCancel={() => setConfirmPopup(false)} />
            </div>
        </div>
    }

    if (deadMode === DeadModeEnum.Logs) {
        return <div className="mafia-container-wrapper">
            <div className="mafia-container">
                <SubHeader>
                    Dead Man Logs
                </SubHeader>
                <GameLogs/>
            </div>
            <Footer>
                <button onClick={() => setDeadMode(DeadModeEnum.Dead)}>Back</button>
            </Footer>
        </div>
    }

    if (deadMode === DeadModeEnum.Details) {
        return <div className="mafia-container-wrapper">
            <div className="mafia-container">
                <SubHeader>
                    Dead Man Details
                </SubHeader>
                <div className="mafia-lobby-container mafia-list-container">
                    <div className="mafia-player-list dead-man-list">
                        {deadView?.state?.map((deadPlayer, index) => {
                            const oddEven = index % 2 == 0 ? 'odd' : 'even reverted';
                            const role = ScenarioUtils.CheckRole(deadPlayer.role_name);
                            let label = 'T';
                            let labelClass = 'label-town';
                            if(role === RoleClassEnum.Mafia){
                                label = 'M';
                                labelClass = 'label-mafia';
                            } else if(role === RoleClassEnum.Neutral) {
                                label ='N';
                                labelClass = 'label-neutral';
                            }
                            
                            return <div className={`dead-man-row ${oddEven}`}>
                                <div className={`label ${labelClass}`}>{label}</div>
                                <div className="pos">{index+1}</div> 
                                <div className={`name ${deadPlayer.is_dead ? 'mafia' : ''}`}>{`${deadPlayer.role_name} ${deadPlayer.name}`}</div>  
                                {deadPlayer.is_dead ? <div className="status label label-mafia">DEAD</div> : <div className="status label label-town">ALIVE</div>}
                            </div>
                        })}
                    </div>
                </div>
            </div>
            <Footer>
                <button onClick={() => setDeadMode(DeadModeEnum.Dead)}>Back</button>
            </Footer>
        </div>
    }

    return <div className="mafia-container-wrapper">
        <div className="mafia-container">
            <SubHeader>
                You are Dead
            </SubHeader>
            <div className="mafia-grave">
                <img src={grave}/>
            </div>
        </div>
        <Footer>
            <button onClick={() => setDeadMode(DeadModeEnum.Details)}>Game Details</button>
            <button onClick={() => setDeadMode(DeadModeEnum.Logs)}>Logs</button>
            {role === 'admin' && <button onClick={() => setConfirmPopup(true)}>End {isNight ? 'Night' : 'Day'}</button>}
        </Footer>
    </div>
}

export default Dead;
